var map = {
	"./awesomeAmsterdamLogo.webp": 4561,
	"./bookingComLogo.webp": 9782,
	"./codeInLogo.webp": 7008,
	"./getirLogo.webp": 3173,
	"./googleAssistantLogo.webp": 2905,
	"./greenHomeLogo.webp": 2433,
	"./jasperschulteComLogo.webp": 6575,
	"./nextuLogo.webp": 2953,
	"./pwaLogo.webp": 9943,
	"./saayaHealthLogo.webp": 7788,
	"./snappCarLogo.webp": 200,
	"./tripAdvisorLogo.webp": 3563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8088;